// ---------------------------------------------------------------------------
// Copy-to-clipboard. Put `data-copy-target="#elementId"` on a button to copy
// that element's text, or `data-copy="literal text"` to copy a literal value.
// Shows a transient "Kopierat!" confirmation on the button.
// ---------------------------------------------------------------------------

async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

function resolveText(button: HTMLElement): string | null {
  const targetSel = button.dataset.copyTarget;
  if (targetSel) {
    const el = document.querySelector(targetSel);
    return el?.textContent?.trim() ?? null;
  }
  return button.dataset.copy ?? null;
}

export function initClipboard(): void {
  document.addEventListener("click", async (event) => {
    const button = (event.target as HTMLElement).closest<HTMLElement>(
      "[data-copy],[data-copy-target]",
    );
    if (!button) return;

    event.preventDefault();
    const text = resolveText(button);
    if (!text) return;

    const ok = await copyText(text);
    const original = button.dataset.label ?? button.textContent ?? "";
    button.dataset.label = original;
    button.textContent = ok ? "Kopierat!" : "Kunde inte kopiera";
    window.setTimeout(() => {
      button.textContent = button.dataset.label ?? original;
    }, 1500);
  });
}
